import Vue from 'vue';

class NotificationService {
  constructor() {}

  warn(title, text) {
    Vue.notify({
      group: 'notifs',
      type: 'warn',
      title,
      text,
      duration: 30000,
      speed: 1000
    });
  }

  onError(message) {
    // eslint-disable-next-line no-console
    console.error('ERROR', message);
    Vue.notify({
      group: 'notifs',
      type: 'error',
      title: 'Error',
      text: message,
      duration: 1000,
      speed: 1000
    });
  }

  onSuccess(message) {
    Vue.notify({
      group: 'notifs',
      type: 'success',
      title: 'Success',
      text: message,
      duration: 1000,
      speed: 1000
    });
  }
}

export default new NotificationService();
